import FMMatrix from '@/models/fm_matrix';

let loadingPromise;

export const foerderungenLoader = {
  methods: {
    loadFoerderungen() {
      if (!loadingPromise) {
        loadingPromise = FMMatrix.api().get('/api/fm_matrix');
      }
      return loadingPromise;
    }
  }
};
